import { Box, Button, TextField, useTheme } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import { mockDataTeam } from "../../../data/mockData";
import Header from "../../../components/Header";

const DetalhesProjeto = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Encontra o projeto a ser exibido pelos detalhes
  const project = mockDataTeam.find((project) => project.id === parseInt(id));

  return (
    <Box m="20px">
      <Header title="Detalhes do Projeto" subtitle="Veja os detalhes do projeto" />
      <Box
        component="form"
        sx={{
          display: 'grid',
          gap: '30px',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          backgroundColor: colors.primary[400],
          padding: '20px',
          borderRadius: '8px',
          "& > div": { gridColumn: "span 4" },
        }}
      >
        <TextField
          label="Nome do Projeto"
          name="projectName"
          value={project.projectName}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Gerente"
          name="manager"
          value={project.manager}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Email"
          name="email"
          value={project.email}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Telefone"
          name="phone"
          value={project.phone}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Morada"
          name="address"
          value={project.address}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 4" }}
        />
        <TextField
          label="Cidade"
          name="city"
          value={project.city}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Responsável pelo Projeto (PF Auditores)"
          name="projectLead"
          value={project.projectLead}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
          sx={{ gridColumn: "span 2" }}
        />
        <Box display="flex" justifyContent="space-between" sx={{ gridColumn: "span 4" }}>
          <Button variant="contained" color="primary" onClick={() => navigate(`/projetos/editar/${id}`)}>
            Editar
          </Button>
          <Button variant="contained" color="secondary" onClick={() => navigate("/projetos")}>
            Voltar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DetalhesProjeto;
